import { useLocalStore } from '@/context/StateContext';
import { Editor } from '@tiptap/core';
import { createEffect, createSignal, JSX, onCleanup } from 'solid-js';
import * as Y from 'yjs';
// import { customPrompt } from './Prompt';

export interface ControlProps extends JSX.ButtonHTMLAttributes<HTMLButtonElement> {
  class: string;
  editor: Editor;
  title: string;
  key: string;
  onChange: () => void;
  isActive?: (editor: Editor) => boolean;
  children: JSX.Element;
}

export interface ToolbarProps {
  editor: Editor;
}

export const addYoutubeVideo = async (editor: Editor, src: string) => {
  editor.chain().focus().setYoutubeVideo({ src, width: 640, height: 480 }).run()
}

export const addImage = (editor: Editor, src: string) => {
  editor.chain().focus().setImage({ src }).run()
}

export const setLink = (editor: Editor, url: string) => {
  createEffect(() => {
    const previousUrl = editor.getAttributes('link').href

    // cancelled
    if (url === null) {
      return
    }

    // empty
    if (url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink()
        .run()

      return
    }

    // update link
    try {
      editor.chain().focus().extendMarkRange('link').setLink({ href: url })
        .run()
    } catch (e) {
      if (e instanceof Error) {
        alert(e.message);
      }
    }
  }, [editor])
}

export const setTable = (editor: Editor) => {
  const rowsString = window.prompt('Enter the number of rows', '3')
  const colsString = window.prompt('Enter the number of columns', '3')
  const rows = Number(rowsString)
  const cols = Number(colsString)

  editor.chain().focus().insertTable({ rows, cols }).run()
}

export const colors = [
  '#958DF1',
  '#F98181',
  '#FBBC88',
  '#FAF594',
  '#70CFF8',
  '#94FADB',
  '#B9F18D',
  '#C3E2C2',
  '#EAECCC',
  '#AFC8AD',
  '#EEC759',
  '#9BB8CD',
  '#FF90BC',
  '#FFC0D9',
  '#DC8686',
  '#7ED7C1',
  '#F3EEEA',
  '#89B9AD',
  '#D0BFFF',
  '#FFF8C9',
  '#CBFFA9',
  '#9BABB8',
  '#E3F4F4',
]

export const getRandomElement = (list: string | any[]) => list[Math.floor(Math.random() * list.length)]

